import React, { FC } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig, selectNcFiles, selectNcFileId } from '@reducers/details';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';
import { NCFileTraceabilityContent } from '@v2/pages/common/components/NCFileTraceabilityContent';
import { DETAILS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

const JobDetailsNCFileTraceability: FC = () => {
  const dispatch = useAppDispatch();
  const ncFiles = useSelector(selectNcFiles);
  const ncFileId = useSelector(selectNcFileId);
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig: (config) => dispatch(updateHeaderConfig(config)),
    operationsSearch: (params) => dispatch(operationsSearch(params)),
    getNCFilesByProductionOperationId: (id, filters) => dispatch(getNCFilesByProductionOperationId(id, filters)),
    getProductionBatchByProductionOperationId: (params) => dispatch(getProductionBatchByProductionOperationId(params)),
    getAllNcFiles: true,
  });

  // Job (operation) can link many NC files — anchor the graph on the first of the list.
  const anchorNcFileId = ncFiles.data?.[0]?.ncFileId ?? ncFileId ?? null;

  return (
    <JobContentWrapper loading={false} title={title.ncFile}>
      <View style={DETAILS_SCREENS_CONTAINER_STYLES}>
        <NCFileTraceabilityContent ncFileId={anchorNcFileId} resolving={!ncFiles.wasLoaded} />
      </View>
    </JobContentWrapper>
  );
};

export { JobDetailsNCFileTraceability };
